import React, { useContext, useMemo } from 'react';

const SimpleLine = ({ relationGraph, link, line }) => {
  const graphContext = relationGraph;

  const lineOptions = graphContext.options;
  const isCheckedLine = line.id === lineOptions.checkedLineId;
  const showStartArrow = line.showStartArrow && graphContext.getArrow(line, link, true);
  const showEndArrow = line.showEndArrow && graphContext.getArrow(line, link, false);

  let path = null;
  let textTransform = {};

  try {
    const { path: linePath, textPosition } = graphContext.createLinePath(link, line, 30);
    path = linePath;

    try {
      textTransform = graphContext.getTextTransform(line, textPosition.x - 20, textPosition.y, textPosition.rotate);
    } catch {}
  } catch {}

  const onLineClick = (event) => {
    graphContext.onLineClick(line, link, event);
  };

  return (
    <g className={`c-rg-line-hover ${line.styleClass}`}>
      <path
        d={path}
        className={`c-rg-line ${line.styleClass} ${isCheckedLine ? 'c-rg-line-checked' : ''}`}
        stroke={isCheckedLine ? line.checkedLineColor : line.color ? line.color : lineOptions.defaultLineColor}
        style={{
          opacity: line.opacity,
          strokeWidth: `${line.lineWidth ? line.lineWidth : lineOptions.defaultLineWidth}px`
        }}
        markerStart={showStartArrow}
        markerEnd={showEndArrow}
        fill="none"
        onClick={onLineClick}
      />

      {lineOptions.defaultShowLineLabel && (
        <g transform={textTransform}>
          <rect
            key={`t-${link.seeks_id}`}
            rx="15"
            ry="15"
            x={10}
            y={-10}
            style={{
              visibility: !line.styleClass ? "hidden" : "",
              opacity: 1,
              fill: line.color
            }}
            className="c-rg-line-text-bg"
            onClick={onLineClick}
          />

          <text
            x={line.text.length > 2 ? 14 : 16}
            y={5}
            style={{
              visibility: !line.styleClass ? "hidden" : "",
              opacity: 1,
              fill: line.fontColor
            }}
            className="c-rg-line-text"
            onClick={onLineClick}
          >
            {line.text}
          </text>
        </g>
      )}
    </g>
  );
};

export default SimpleLine;